export default __webpack_public_path__ + "static/media/maa.6fc81a01.svg";